import { render, staticRenderFns } from "./surprisersItem.vue?vue&type=template&id=5967dc2b&"
import script from "./surprisersItem.vue?vue&type=script&lang=js&"
export * from "./surprisersItem.vue?vue&type=script&lang=js&"
import style0 from "./surprisersItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports